export default __webpack_public_path__ + "media/images/temporary/faq-hero-498d03143ddd13adf853db601108404c.jpg";